import { VARIANTS } from '@jobcase/react_pattern_library/components/Toaster/Toaster';

import entity from '../../entities/jobCampaigns/entity';

import { getProfileKey } from '../../authentication/selectors';
import { setNotification } from '../../notification/actions';

import { isEmpty } from '../../../../utils/utils';
import { getCurrentEmployer } from '../employers/selectors';

const TYPES = {
  ...entity.getTypes(),
  GET_SITE_IDS_REQUEST: `${entity.name}/GET_SITE_IDS_REQUEST`,
  GET_SITE_IDS_FAILURE: `${entity.name}/GET_SITE_IDS_FAILURE`,
  GET_SITE_IDS_SUCCESS: `${entity.name}/GET_SITE_IDS_SUCCESS`,
  GET_NODES_REQUEST: `${entity.name}/GET_NODES_REQUEST`,
  GET_NODES_FAILURE: `${entity.name}/GET_NODES_FAILURE`,
  GET_NODES_SUCCESS: `${entity.name}/GET_NODES_SUCCESS`,
  CREATE_CAMPAIGN_REQUEST: `${entity.name}/CREATE_CAMPAIGN_REQUEST`,
  CREATE_CAMPAIGN_FAILURE: `${entity.name}/CREATE_CAMPAIGN_FAILURE`,
  CREATE_CAMPAIGN_SUCCESS: `${entity.name}/CREATE_CAMPAIGN_SUCCESS`,
  UPDATE_FILTER_OPTIONS: 'jobsCampaigns/UPDATE_FILTER_OPTIONS',
  UPDATE_SORT_OPTIONS: 'jobsCampaigns/UPDATE_SORT_OPTIONS',
  UPDATE_SEARCH_QUERY: 'jobsCampaigns/UPDATE_SEARCH_QUERY',
};

export const getAllSiteIds = ctx => async (dispatch, getState) => {
  dispatch({ type: TYPES.GET_SITE_IDS_REQUEST });
  const state = getState();
  const organizationId = getCurrentEmployer(state);
  const profileKey = getProfileKey(state);
  const query = { organization_id: organizationId };
  try {
    const response = await entity.api.getSiteIds({ query, profileKey, ctx });
    const { data } = response;
    dispatch({ type: TYPES.GET_SITE_IDS_SUCCESS, payload: { data } });
    return response;
  } catch (error) {
    dispatch({ type: TYPES.GET_SITE_IDS_FAILURE, payload: error });
    if (!isEmpty(error.errors)) {
      dispatch(setNotification(`An error occurred while loading site ids. ${error.errors[0]}`, VARIANTS.INFO));
    } else {
      dispatch(setNotification('An error occurred while loading site ids.', VARIANTS.INFO));
    }
    throw error;
  }
};

export const clearSiteIds = () => (dispatch) => {
  dispatch({ type: TYPES.CLEAR_SITE_IDS });
};

export const getAllNodes = ctx => async (dispatch, getState) => {
  dispatch({ type: TYPES.GET_NODES_REQUEST });
  const profileKey = getProfileKey(getState());
  const orgId = getCurrentEmployer(getState());
  try {
    const response = await entity.api.getNodes({ orgId, profileKey, ctx });
    const { data } = response;
    dispatch({ type: TYPES.GET_NODES_SUCCESS, payload: { data } });
    return response;
  } catch (error) {
    dispatch({ type: TYPES.GET_NODES_FAILURE, payload: error });
    if (!isEmpty(error.errors)) {
      dispatch(setNotification(`An error occurred while loading nodes. ${error.errors[0]}`, VARIANTS.INFO));
    } else {
      dispatch(setNotification('An error occurred while loading nodes.', VARIANTS.INFO));
    }
    throw error;
  }
};

export const updateFilterOptions = options => (dispatch) => {
  dispatch({ type: TYPES.UPDATE_FILTER_OPTIONS, payload: options });
};

export const updateSearchQuery = options => (dispatch) => {
  dispatch({ type: TYPES.UPDATE_SEARCH_QUERY, payload: options });
};

export const updateSortOptions = options => (dispatch) => {
  dispatch({ type: TYPES.UPDATE_SORT_OPTIONS, payload: options });
};

export {
  TYPES,
};

export default {
  TYPES,
  ...entity.getActions(),
  getAllSiteIds,
  clearSiteIds,
  getAllNodes,
  updateFilterOptions,
  updateSearchQuery,
  updateSortOptions,
};
